import Button from "../form/Button";
import Modal from "../layout/Modal";

import { useSubscriptionCheckoutMutation } from "@/api/billing/useSubscriptionCheckoutMutation";
import { useSubscriptionQuery } from "@/api/billing/useSubscriptionQuery";
import { usePaymentRequiredStore } from "@/stores/paymentRequired.store";
import { useWorkspaceStore } from "@/stores/workspace.store";

function formatCents(cents: number): string {
  return (cents / 100).toFixed(2);
}

export function PaymentRequiredModal() {
  const { isOpen, close } = usePaymentRequiredStore();
  const workspaceId = useWorkspaceStore((s) => s.activeWorkspaceId) ?? "";
  const { data: subData } = useSubscriptionQuery(workspaceId);
  const checkout = useSubscriptionCheckoutMutation();

  const planSlug = subData?.subscription?.plan?.slug;
  const planName = subData?.subscription?.plan?.name;
  const effectivePrice = subData?.subscription?.effectivePrice;

  const handleCheckout = () => {
    if (!workspaceId || !planSlug) return;
    checkout.mutate(
      { workspaceId, planSlug },
      {
        onSuccess: (data) => {
          close();
          if (data.checkoutUrl) {
            window.location.href = data.checkoutUrl;
          }
        },
      },
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={(v) => {
        if (!v) close();
      }}
      title="Wymagana metoda płatności"
    >
      <p className="text-secondary mb-4">
        Aby generować filmy, musisz najpierw opłacić subskrypcję.
      </p>

      {planName && effectivePrice !== undefined && (
        <div className="bg-surface-hover rounded-lg p-4 mb-6">
          <p className="font-medium text-primary">{planName}</p>
          <p className="text-sm text-secondary">
            ${formatCents(effectivePrice)}/mies.
          </p>
        </div>
      )}

      <div className="grid grid-cols-2 gap-3">
        <Button variant="secondary" onClick={close}>
          Anuluj
        </Button>
        <Button
          onClick={handleCheckout}
          disabled={checkout.isPending || !planSlug}
        >
          {checkout.isPending ? "Przekierowywanie…" : "Opłać subskrypcję"}
        </Button>
      </div>
    </Modal>
  );
}
